
<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="img" v-if="images.length > 0">
                    <div v-for="item in images" :key="item.id">
                      <img :src="item.path" alt="" />
                    </div>
                  </div>
                  <div>
                    <div v-for="(item, index) in form.contents" :key="index">
                      {{ item }}
                    </div>
                  </div>
                </div>
                <!-- <div>
                  <p><br /></p>
                  <p><br /></p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {
    id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
      },
      images: [],
      form: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getXxydList();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getXxydList() {
      let params = {
        pageNum: this.search.page,
        pageSize: this.search.size,
        menuId: 24,
      };
      let ldId;
      axios
        .get("/jtg/home/articleList", { params })
        .then((result) => {
          let res = JSON.parse(JSON.stringify(result.data));

          ldId = res.data.items[0].id;

          this.getLdtd(ldId);
        });
    },
    getLdtd(id) {
      // if (this.index != null) {
      axios
        .get("/jtg/home/content/" + id)
        .then((result) => {
          let res = JSON.parse(JSON.stringify(result.data));
          if (res.data) {
            this.form = res.data;
            this.images = res.data.images;
          }
        });
    },
  },
  // },
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          // border-bottom: 1px #444 dashed;
          // height: 500px;
        }
        img {
          height: 60px;
          // height: 326%;
          // position: relative;
          // top: -393px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>